/* eslint-disable */
import {
    GETCHALLANCANDIDATES, CANDIDATEDOCUMENTDETAILS, APPROVALACTIONSHISTORY, UPDATEDOCUMNENTSINFO, OASUSERS, GETAPPLICATIONDETAILS_BY_ADVERTISEMENT, ADDDOCFORAPPROVAL, DOCAPPROVAL, DOCUMENTAPPROVAL, ADVERTISEMENT_DETAILS, ALLACTIVEADVERTISEMENT, SEND_REUPLOAD_DOCUMENT_TO_CANDIDATE, GET_POST_NAMES, GET_EXPERIENCE_AND_QUALIFICATION_APPROVALS,
    ALLPASTADVERTISEMENT, CANDIDATE_DOC_DOWNLOAD, GETADVERTISEMENT, PROFILE_INFO_DISPLAY, QUALIFICATION_TYPES, LOOKUP_OPTION, GET_APPLICATION_DETAILS_BY_ID, PROFILE, CANDIDATE_PROFILE_INFO_DISPLAY, ADVERTISEMENT_DOC_DOWNLOAD, PAST_ADVERTISEMENT_DETAILS, ASSIGNTONEXTAPPROVER, SENDLISTTORESULTSECTION, GET_SCRUTINY_REPORT_DETAILS, SENDTORESULTSECTION, GET_YEAR_LIST
} from "../../common/constants/endpoints";
import API from "../../helpers/API";
import FileDownload from "js-file-download";
import axios from "axios";
import {
    SET_ADVERTISEMENT_DETAILS_AND_CANDIDATE_LIST, SET_SHOW_VERIFY_DOCUMENT_TABLE, SET_SHOW_APPROVE_DOC_MODAL, SET_SHOW_UPDATE_APPROVE_DOC_MODAL, SET_VIEW_EXPERIENCE_AND_QUALIFICATION_MODAL, SET_SHOW_APPROVE_EXPERIENCE_AND_QUALIFICATION_DOC_MODAL, SET_GET_POST_NAMES_DATA, SET_SHOW_SCRUTINY_REPORT_DETAILS, SET_GET_ALL_ACTIVE_ADVERTISEMENT,
    SET_CANDIDATES_BY_ADVERTISEMENT, SET_CANCEL_REJECT_APPLICATIONDATA_BY_ADVERTISEMENT, SET_DOCUMENTLIST_BY_CANDIDATE, SET_PROFILE_INFO_BY_CANDIDATE, SET_CANCEL_REJECT_APPLICATIONS_LIST, SET_VIEW_DOC_MODAL, SET_USER_BY_ADVERTISEMENT, SET_APPROVAL_DOC_LIST, SET_SCRUTINY_REPORT_DETAILS, SET_EXPERIENCE_AND_QUALIFICATION_APPROVAL_ACTION_HISTORY, SET_YEAR,
    SET_ADVERTISEMENT_DETAILS, SET_APPROVAL_ACTION_HISTORY, ADVERTISEMENT_LIST_FOR_DOCUMENT_APPROVAL, SET_ADVERTISEMENT_DETAILS_AND_DOC_APPROVAL_LIST, SET_PROFILE_INFO_DISPLAY, SET_QUALIFICATION_TYPES, SET_PROFILE_CREATION_LOOKUPS, SET_APPLICATION_DETAILS, SET_PROFILE_DETAILS, SET_GET_ACTIVE_ADVERTISEMENT, SET_GET_PAST_ADVERTISEMENT, GET_ADDITIONAL_QUESTIONS_DATA, GET_ADDITIONAL_ANSWERS_DATA
} from '../../common/constants/ActionTypes';
import { hideLoader, showLoader } from '../../common/actions/commonActions';

import { toastr } from 'react-redux-toastr';

export const setAdvertisementDetailsAndCandidateList = (flag) => {
    return async (dispatch) => {

        dispatch({
            payload: flag,
            type: SET_ADVERTISEMENT_DETAILS_AND_CANDIDATE_LIST
        })
    }
};
export const setAdvertisementDetailsAndDocApprovalList = (flag) => {
    return async function (dispatch) {
        dispatch({
            payload: flag,
            type: SET_ADVERTISEMENT_DETAILS_AND_DOC_APPROVAL_LIST
        })
    }
}
export const setVerifyDocumentTableList = (flag) => {
    return async (dispatch) => {

        dispatch({
            payload: flag,
            type: SET_SHOW_VERIFY_DOCUMENT_TABLE
        })
    }

}

export const setApprovalDocumentflag = (flag) => {
    return async (dispatch) => {

        dispatch({
            payload: flag,
            type: SET_SHOW_APPROVE_DOC_MODAL
        })
    }

}

export const setUpdateApprovalDocumentflag = (flag) => {
    return async (dispatch) => {

        dispatch({
            payload: flag,
            type: SET_SHOW_UPDATE_APPROVE_DOC_MODAL
        })
    }

}

export const setExperienceAndQualificationApprovalDocumentflag = (flag) => {
    return async (dispatch) => {

        dispatch({
            payload: flag,
            type: SET_SHOW_APPROVE_EXPERIENCE_AND_QUALIFICATION_DOC_MODAL
        })
    }

}
export const getApprovalActionHistory = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            response = await API.get(APPROVALACTIONSHISTORY + `${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_APPROVAL_ACTION_HISTORY,
                payload: response.data
            })

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getCandidatesByAdvtId = (id, approvalTab, skipPage, limitPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let deptId = session.deptRoles[0].deptId;
        let response;
        let skip = skipPage;
        let limit = limitPage;
        try {
            response = await API.get(GETCHALLANCANDIDATES + `${id}` + '/documentverificationdetails' + `/${deptId}` + `/${approvalTab}` + `/${skip}` + `/${limit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_CANDIDATES_BY_ADVERTISEMENT,
                payload: response.data,
            });

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const resetCandidatesByAdvertisement = () => {
    return async function (dispatch) {

        dispatch({
            type: SET_CANDIDATES_BY_ADVERTISEMENT,
            payload: [],
        });
    }
}
export const getDocumentListByCandidateId = (applID) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(CANDIDATEDOCUMENTDETAILS + `${applID}`, {
                headers: { Authorization: `Bearer ${token}` },
            });


            dispatch({
                type: SET_DOCUMENTLIST_BY_CANDIDATE,
                payload: response.data.verifyDocumentInfoDto
                    .map((doc, index) => ({ ...doc, isInterested: false })),
            });
            dispatch({
                type: SET_PROFILE_INFO_BY_CANDIDATE,
                payload: response.data.profileInfo
            });

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const updateDocument = (data) => {
    return async function (dispatch) {
        let applicationId = data.applicationId;
        let documentTypeId = data.documentTypeId;
        let requestBody = {
            comments: data.comments,
            type: data.type
            //isFinal: data.isFinal
        }
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;

        try {
            let response;
            response = await API.patch(UPDATEDOCUMNENTSINFO + `${applicationId}` + '/' + `${documentTypeId}`, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(setApprovalDocumentflag(false));
            dispatch(setUpdateApprovalDocumentflag(false));
            dispatch(getDocumentListByCandidateId(applicationId))
            if (data.type == 'Approved') {
                toastr.success("Document Approved successfully")
            }
            if (data.type == 'Rejected') {
                toastr.success("Document Reject successfully")
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const viewAndDownloadDocument = (flag) => {
    return async (dispatch) => {
        dispatch({
            payload: flag,
            type: SET_VIEW_DOC_MODAL
        })
    }

}

export const viewExperienceAndQualificationDocument = (flag) => {
    return async (dispatch) => {
        dispatch({
            payload: flag,
            type: SET_VIEW_EXPERIENCE_AND_QUALIFICATION_MODAL
        })
    }

}

export const getUserByAdvtId = (advtId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(OASUSERS + `${advtId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_USER_BY_ADVERTISEMENT,
                payload: response.data,
            });

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getActiveAdvertisementForDocumentApprovalList = (skipPage, limitPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let deptId = session.deptRoles[0].deptId;
        let response;
        let pagneno = skipPage
        let size = limitPage
        try {
            response = await API.get(ALLACTIVEADVERTISEMENT + `/${deptId}` + `/${pagneno}` + `/${size}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: ADVERTISEMENT_LIST_FOR_DOCUMENT_APPROVAL,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getAllAdvertisementForDocumentApprovalList = (skipPage, limitPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let deptId = session.deptRoles[0].deptId;
        let response;
        let pagneno = skipPage
        let size = limitPage
        try {
            response = await API.get(GETADVERTISEMENT + `/${deptId}` + `/${pagneno}` + `/${size}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: ADVERTISEMENT_LIST_FOR_DOCUMENT_APPROVAL,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getPastAdvertisementForDocumentApprovalList = (skipPage, limitPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let deptId = session.deptRoles[0].deptId;
        let response;
        let pagneno = skipPage
        let size = limitPage
        try {
            response = await API.get(ALLPASTADVERTISEMENT + `/${deptId}` + `/${pagneno}` + `/${size}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: ADVERTISEMENT_LIST_FOR_DOCUMENT_APPROVAL,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getCancelRejectApplication = (advtId, action, skipPage, limitPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let pagneno = skipPage
        let size = limitPage
        try {
            if (advtId && action) {
                response = await API.get(GETAPPLICATIONDETAILS_BY_ADVERTISEMENT + `${advtId}` + `/${action}` + `/${pagneno}` + `/${size}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            dispatch({
                type: SET_CANCEL_REJECT_APPLICATIONDATA_BY_ADVERTISEMENT,
                payload: response.data,
            });

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const documentApproval = (reqBody) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(DOCUMENTAPPROVAL, reqBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getDocumentApprovalList(reqBody.applicationId));
            dispatch(setApprovalDocumentflag(false));
            dispatch(setUpdateApprovalDocumentflag(false));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
};

export const updateDocumentApproval = (reqBody) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(DOCUMENTAPPROVAL, reqBody, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getDocumentApprovalList(reqBody.applicationId));
            dispatch(setApprovalDocumentflag(false));
            dispatch(setUpdateApprovalDocumentflag(false));
            toastr.success(response.data.message);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
};

export const addDocumentForApproval = (reqBody) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADDDOCFORAPPROVAL, reqBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            toastr.success("Document Approval Request Submit successfully");
            // dispatch(getDocumentApprovalList());
            //dispatch(getDocumentListByCandidateId(reqBody.applicationId))
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getDocumentApprovalList = (appId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let userId = session.userId
        let deptId = session.deptRoles[0].deptId;
        let response;
        try {
            response = await API.get(DOCAPPROVAL + `${userId}` + `/${deptId}` + `/${appId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_APPROVAL_DOC_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const resetCheckDocumentList = () => {
    return async function (dispatch, getState) {
        const { documentListByCandidate } = getState().documentVerificationReducer;
        dispatch({
            type: SET_DOCUMENTLIST_BY_CANDIDATE,
            payload: documentListByCandidate
                .map((doc, index) => ({ ...doc, isInterested: false })),
        });
    }
}

export const viewCancelRejectApplication = (flag) => {
    return async (dispatch) => {
        dispatch({
            payload: flag,
            type: SET_CANCEL_REJECT_APPLICATIONS_LIST
        })
    }
};

export const getAdvertisementDetails = (skipPage, limitPage, year, deptID) => {
    return async function (dispatch) {

        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let reqBody = {
            "year": year,
            // "year": year.getFullYear(),
            "showBoth": true,
            "deptId": deptID
        }
        let response;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        try {
            response = await API.post(ADVERTISEMENT_DETAILS + `/${skip}` + `/${pageLimit}`, reqBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch({
                type: SET_ADVERTISEMENT_DETAILS,
                payload: response.data
            })

        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const downloadDocumentOfCandidate = (profileID) => {
    return async () => {
        let response;
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            const token = session.jwtResponse && session.jwtResponse.token;
            response = await axios.request({
                url: CANDIDATE_DOC_DOWNLOAD + `/${profileID}`,
                method: "GET",
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            toastr.error("Document not available to download");
            return;
        }
        FileDownload(
            response.data,
            `Documents_${profileID}.zip`
        );
    };
};

export const getProfileInfoDisplay = (profileId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        if (!profileId) {
            profileId = session.profileId;
        }
        let response;
        try {
            response = await API.get(PROFILE_INFO_DISPLAY + `/${profileId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (err) {
            toastr.error("Error getting profile information");
            return;
        }
        dispatch({
            type: SET_PROFILE_INFO_DISPLAY,
            payload: response.data,
        });
    };
};

export const getCandidateProfileInfoDisplay = (profileId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        if (!profileId) {
            profileId = session.profileId;
        }
        let response;
        try {
            response = await API.get(CANDIDATE_PROFILE_INFO_DISPLAY + `/${profileId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if ((response.data) && (response.data.application) && (response.data.application.advertisement.additionalQuestions)) {
                let additionalQuestions = JSON.parse(response.data.application.advertisement.additionalQuestions);
                dispatch({
                    type: GET_ADDITIONAL_QUESTIONS_DATA,
                    payload: additionalQuestions,
                });
            }
            if ((response.data) && (response.data.application) && (response.data.application.additionalAnswers)) {
                let additionalAnswers = JSON.parse(response.data.application.additionalAnswers);
                dispatch({
                    type: GET_ADDITIONAL_ANSWERS_DATA,
                    payload: additionalAnswers,
                });
            }
            dispatch({
                type: SET_PROFILE_INFO_DISPLAY,
                payload: response.data,
            });
        } catch (err) {
            toastr.error("Error getting profile information");
            return;
        }
    };
};

export const setProfileCreationDropdown = () => {
    return async (dispatch) => {

        let response = await API.get(LOOKUP_OPTION, {
            params: { module: "profile_creation" }
        });
        dispatch({
            payload: (response && response.data) ? response.data : [],
            type: SET_PROFILE_CREATION_LOOKUPS
        });
    }
};

export const getAllQualificationTypes = () => {
    return async (dispatch) => {
        try {
            // const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            // let token = session.jwtResponse && session.jwtResponse.token

            let response = await API.get(QUALIFICATION_TYPES);

            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_QUALIFICATION_TYPES
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error("Error While Fetching the Qualification Types:", errorMessage);
        }
    }
};

export const getApplicationDetails = (appId) => {
    return async (dispatch) => {
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            let token = session.jwtResponse && session.jwtResponse.token

            let response = await API.get(GET_APPLICATION_DETAILS_BY_ID + `/${appId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_APPLICATION_DETAILS
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error(errorMessage);
        }
    }
};

export const getProfileDetails = (profileId) => {
    return async (dispatch) => {
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            let token = session.jwtResponse && session.jwtResponse.token

            let response = await API.get(PROFILE + `/${profileId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_PROFILE_DETAILS
                });
            }

        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
            toastr.error(errorMessage);
        }
    }
};
export const downloadDocumentsOfAdvertisement = (advtId, appId, advtNo,) => {
    return async () => {
        let response;
        let folderName = `All Documents_${advtNo}.zip`;
        if (advtId && appId && advtNo) {
            folderName = `Documents_Advertisement_No_${advtNo}.zip`;
        };

        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            const token = session.jwtResponse && session.jwtResponse.token;
            let urlString = ADVERTISEMENT_DOC_DOWNLOAD + `?advtid=${advtId}`;
            if (advtId && appId && advtNo) {
                urlString = ADVERTISEMENT_DOC_DOWNLOAD + `?advtid=${advtId}` + `&appid=${appId}`;
            }
            response = await axios.request({
                url: urlString,
                method: "GET",
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            toastr.error("Document not available to download");
            return;
        }
        FileDownload(
            response.data,
            folderName,
            // `Documents_Advertisement_No_${advtNo}.zip`
        );
    };
};

export const getActiveAdvertisementDetails = (skipPage, limitPage, year) => {
    return async function (dispatch) {

        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        try {
            response = await API.get(GETADVERTISEMENT + `/${skip}` + `/${pageLimit}`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { "year": year }
                // params: { "year": year.getFullYear() }
            });

            dispatch({
                type: SET_GET_ACTIVE_ADVERTISEMENT,
                payload: response.data
            })

        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getPastAdvertisementDetails = (skipPage, limitPage, year) => {
    return async function (dispatch) {

        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        try {
            response = await API.get(PAST_ADVERTISEMENT_DETAILS + `/${skip}` + `/${pageLimit}`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { "year": year }
            });

            dispatch({
                type: SET_GET_PAST_ADVERTISEMENT,
                payload: response.data
            })

        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const assignToNextApprover = (advid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(ASSIGNTONEXTAPPROVER + `/${advid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.status === 200) {
                toastr.success("Applications assigned to next Approver.");
                window.location.reload();
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const SendReuploadDocumentToCandidate = (advid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(SEND_REUPLOAD_DOCUMENT_TO_CANDIDATE + `/${advid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.status === 200) {
                window.location.reload();
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const sendListToResultSection = (isEligibleList, advid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(SENDTORESULTSECTION + `/${isEligibleList}` + `/${advid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.status === 200) {
                toastr.success(response.data);
                window.location.reload();
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const candidateIsEligibleOrNot = (advid, isEligible) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(SENDLISTTORESULTSECTION + `/${advid}` + `/${isEligible}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.status === 200) {
                toastr.success(response.data);
                // window.location.reload();
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getPostNames = (advertisementId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            response = await API.get(GET_POST_NAMES + `/${advertisementId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_POST_NAMES_DATA,
                payload: response.data
            })

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getScrutinyReportDetails = (advertisementId, postCriteriaId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            response = await API.get(GET_SCRUTINY_REPORT_DETAILS + `/${advertisementId}` + `/${postCriteriaId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_SCRUTINY_REPORT_DETAILS,
                payload: response.data
            })

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const setShowScrutinyReport = (flag) => {
    return async (dispatch) => {

        dispatch({
            payload: flag,
            type: SET_SHOW_SCRUTINY_REPORT_DETAILS
        })
    }

}

export const getExperienceAndQualificationApprovals = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            response = await API.get(GET_EXPERIENCE_AND_QUALIFICATION_APPROVALS + `${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_EXPERIENCE_AND_QUALIFICATION_APPROVAL_ACTION_HISTORY,
                payload: response.data
            })
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getAllActiveAdvertisements = (year, examCenterId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let examcenterid = examCenterId ? examCenterId : "";
        try {
            response = await API.get(GETADVERTISEMENT + `?examcenterid=${examcenterid}`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { "year": year }
            });
            dispatch({
                type: SET_GET_ALL_ACTIVE_ADVERTISEMENT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getYearList = () => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            let response = await API.get(`${GET_YEAR_LIST}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response) {

                dispatch({
                    payload: response.data,
                    type: SET_YEAR,
                });
            }
            dispatch(hideLoader());
        } catch (error) {
            dispatch(hideLoader());
            if (error && error.response) {
                let errorMessage =
                    error && error.response && error.response.data
                        ? error.response.data.message
                        : error.message;
                toastr.error(errorMessage);
                return;
            }
        }
    };
};